import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject, timer } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { interpolateLinks } from '../../../shared/helpers/interpolate-links';
import { LogoutService } from '../../../shared/logout.service';
import { OeAppPersonService } from '../../../shared/oe-app-person.service';
import { TranslationService } from '../../../shared/translation.service';

const INITIAL_SECONDS = 5;
const LEVEL_EXAM_PATH = '/level-exam.html';
const FORCE_LOG_OUT_BODY_KEY_PREFIX = 'endOfLevelExam.forceLogOut.body';
const GENERAL_BODY_KEY = `${FORCE_LOG_OUT_BODY_KEY_PREFIX}.general`;

@Component({
  selector: 'lp2-force-log-out-modal',
  templateUrl: './force-log-out-modal.component.html',
  styleUrls: ['./force-log-out-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForceLogOutModalComponent implements OnInit, OnDestroy {
  secondsRemaining: number = INITIAL_SECONDS;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly logoutService: LogoutService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly translationService: TranslationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly sanitizer: DomSanitizer
  ) {}

  get bodyMessageKey(): string {
    const category = this.oeAppPersonService.productCategory;
    const specificKey = `${FORCE_LOG_OUT_BODY_KEY_PREFIX}.${category}`;
    const specificTextKey = `${specificKey}.text`;
    const translated = this.translationService.translate(specificTextKey);
    if (translated === specificTextKey) {
      return GENERAL_BODY_KEY;
    }
    return specificKey;
  }

  get bodyMessageHtml(): string {
    const textKey = `${this.bodyMessageKey}.text`;
    const urlKey = `${this.bodyMessageKey}.url`;
    const text = this.translationService.translate(textKey);
    const url = this.translationService.translate(urlKey);
    const hasUrl = url !== urlKey;
    if (!hasUrl) {
      return text;
    }
    const safeUrl = this.sanitizer.sanitize(SecurityContext.URL, url) || '';
    return interpolateLinks(text, [safeUrl]);
  }

  ngOnInit() {
    timer(0, 1000)
      .pipe(
        take(INITIAL_SECONDS + 1),
        map((tick) => INITIAL_SECONDS - tick),
        takeUntil(this.destroy$)
      )
      .subscribe((seconds) => {
        this.secondsRemaining = seconds;
        this.cdr.markForCheck();
        if (seconds <= 0) {
          this.logoutService.logout(LEVEL_EXAM_PATH);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// WEBPACK FOOTER //
// ./ts/app/exams/end-of-level-exam/force-log-out-modal/force-log-out-modal.component.ts